import { Box, Stack, Typography } from "@mui/material";
import { PRODUCT_INFO } from "../../../locales/components/namespaces";
import { useTranslation } from "react-i18next";
import useUserData from "../../../hooks/user/useUserData";

const TOKENS = {
  label: "#111111",
  dotIdleRing: "#E9E9E9",
  dotSelectedRing: "#111111",
  dotSize: 14,
  ringSize: 22,
    dotFallback: "#BDBDBD",
};

export default function ProductColorSelector({ colors = [], value, onChange,product }) {

  const { t } = useTranslation(PRODUCT_INFO);
  const {language} = useUserData()
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 3,}}>
      <Typography
        variant="caption"
        sx={{
          color: TOKENS.label,
          fontWeight: 700,
          lineHeight: "120%",
          fontFamily: "Roboto Condensed",
          fontSize: 14,
          display: "inline-flex",
          alignItems: "center",
          height: TOKENS.ringSize,
          whiteSpace: "nowrap",
        }}
      >
        {t("choose_color")}
      </Typography>

      <Stack direction="row" spacing={1} alignItems="center">
        {colors.map((c) => {
            const colorId = c.itemId;
            const selected = String(colorId) === String(value);

            const label =
                language === "el" ? (c.nameEL ?? "") : (c.nameEN ?? "");

            const dot = c.hex ?? TOKENS.dotFallback;
          return (
            <Box
                key={colorId}
                onClick={() => onChange(colorId)}
              role="button"
              aria-label={label}
              sx={{
                position: "relative",
                width: TOKENS.ringSize,
                height: TOKENS.ringSize,
                borderRadius: "50%",
                cursor: "pointer",
                display: "grid",
                placeItems: "center",
                  border: `1px solid ${selected ? TOKENS.dotSelectedRing : TOKENS.dotIdleRing}`,
                  //transition: "border-color .15s ease",
              }}
            >
              <Box
                sx={{
                  width: TOKENS.dotSize,
                  height: TOKENS.dotSize,
                  borderRadius: "50%",
                  bgcolor: dot,
                  boxShadow:
                    dot?.toLowerCase() === "#ffffff"
                      ? "inset 0 0 0 1px rgba(0,0,0,.1)"
                      : "none",
                }}
              />
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
}
